import { observable, action, computed } from 'mobx';
import URIs from 'const/URIs';
import request from 'utils/request';
import UserStatusType from 'consts/UserStatusType';
import Axios from 'axios';


interface ILoginForm {
  name: string;
  userCk: string;
}

interface IUserNowRes {
  ptCount: number;
  userStatusType: UserStatusType;
}

interface IAgreePrivacyPolicyRes {
  ptCount: number;
  userCk: string;
  userStatusType: UserStatusType;
}

interface IUserInfo {
  id: number;
  limitTime: string;
  name: string;
  receiveEndDatetime: string;
  receiveStartDatetime: string;
  recruitNoticeName: string;
  recruitSectorName: string;
  userCk: string;
  userStatusType: UserStatusType;
  isAgreePrivacyPolicy: string;
}

interface ICompany{
  logo: string;
  managerEmail: string;
  managerName: string;
  managerPhone: string;
  privacyPolicyContents: Array<PrivacyPolicyContent>;
}
export interface PrivacyPolicyContent{
  privacyPolicySn: number;
  privacyPolicyName: string;
  postYn: boolean;
  creatorName: string;
  createDatetime: string;
  modifierName: string;
  modifyDatetime: string;
  privacyPolicyContents: string;
}

export default class Login {
    @observable isLogin = false;
    @observable isError = false;
    @observable isAgreeCheck = false;
    @observable isAgreeCheckView = false;
    @observable userInfo?: IUserInfo;
    @observable errorMsg: any=`현재 온라인 PT 응시기간이 아닙니다.${"\n"}응시기간을 확인하세요.`;
    @observable companyInfo?: ICompany;
    @observable audio?: string;
    @observable ptCount = 0;
    @observable error401 = false;

    URL_TTS='https://midas-online.recruiter.co.kr/interview';
    
    @action
    login = async (form: ILoginForm) => {
        // const formData = new FormData();
        // formData.append('name',form.name);
        // formData.append('inAirKey',form.inAirKey);
      try {
        await request({
          method: 'post',
          url: URIs.login,
          data: form
        }).then(async (response) => {
        //   this.userInfo=response;
            // if(response.state==302)
         
            await this.getUserInfo();
                  this.isLogin = true;
        })
    
      }catch (e) {
          if(e.response?.data?.message)
            this.errorMsg = e.response.data.message;
          this.isError=true;
        throw e;
      } 
    }
    
    @action
    logout = () => {
      this.userInfo = undefined;
      this.isLogin = false;
      this.ptCount = 0;
    }

    @action
    getUserInfo = async () => {
      try {
        if(!this.userInfo)
        await request({
          method: 'get',
          url: URIs.get_user,
        }).then((response) => {
            this.userInfo=response;
        })
    
      }catch (e) {
        throw e;
      } 
    }

    @action
    loginCheck = async () => {
      try {
        await request({
          method: 'get',
          url: URIs.get_user,
        }).then((response) => {
            // this.isLogin = true;
        })
    
      }catch (e) {
        throw e;
      } 
    }
    @action
    setPrivacyPolicy = async () => {
      try {
        const res = await request<IAgreePrivacyPolicyRes>({
          method: 'post',
          url: URIs.agree_privacy_policy,
        })
        this.ptCount = res.ptCount;
    
      }catch (e) {
        throw e;
      } 
    }
  
    @action
    getCompanyInfo=async()=>{
     
  
      try {
        const domain= process.env.REACT_APP_ENV === 'development' ? 'https://demo01-admin-recruiter-co-kr.kr-dv-midasitwebsol.com':window.location.hostname

        if(!this.companyInfo)
        await request({
          method: 'get',
          url: URIs.company,
          params:{domain:domain}
        }).then((response) => {
           this.companyInfo = response;
        })
    
      }catch (e) {
        throw e;
      } 
    }
    


    @action
    goCalibration = async () => {
    
      try {
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', '/');
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', 'success');
        hiddenField.setAttribute('value', 'false');
        form.appendChild(hiddenField);
        document.body.appendChild(form);
        form.submit();
      }catch (e) {
        throw e;
      } 
    }

    @action
    updateUserStatusType = async (userStatusType: UserStatusType) => {
      await request({
        method: 'post',
        url: URIs.post_user_status_type,
        data: { userStatusType }
      });
    }

    @action
    updateNow = async () => {
      try {
        const userNow = (await request<IUserNowRes>({
          method: 'get',
          url:URIs.get_user_now,
        }));
        this.ptCount = userNow.ptCount;
        if(this.userInfo)
          this.userInfo.userStatusType = userNow.userStatusType;
      } catch (e) {
        if(e.response?.status === 401) {
          this.error401 = true;
        }
      }
    }

    @computed
    get ptCountCheck() {
      return !this.error401 && (this.ptCount < 3 && this.userInfo?.userStatusType !== UserStatusType.COMPLETED && this.userInfo?.userStatusType !== UserStatusType.ENCODING_COMPLETED);
    }

    @action
    getTTS = async (text: string) => {
      try {
       await Axios.get(
          `${this.URL_TTS}/doTTS`,{
            withCredentials: false,
            params: {text}
          }
        //   {
        //   method: 'get',
        //   // url: `http://kr-dv-midasitwebsol.com/interview/doTTS`,
        //   url: `https://demo01-video-recruiter-co-kr.kr-dv-midasitwebsol.com/api/doTTS`,
        //   params:{text:text}
        // }
        ).then((response) => {
            // this.isLogin = true;
            this.audio=response.data;
        })
    
      }catch (e) {
        throw e;
      } 
    }
}